var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40 80c22.091 0 40-17.909 40-40S62.091 0 40 0 0 17.909 0 40s17.909 40 40 40"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F3A900",
  d: "M40 19.888c-8.4 0-15.234 6.834-15.234 15.235 0 3.324 1.05 6.482 3.039 9.132l11.256 15.16c.028.037.071.051.102.084.563.602 1.375.45 1.775-.084 3.242-4.324 9.183-12.402 11.468-15.449l.001-.004.014-.018a15.13 15.13 0 0 0 2.813-8.821c0-8.4-6.834-15.235-15.234-15.235m0 23.453c-4.523 0-8.219-3.696-8.219-8.218s3.696-8.22 8.219-8.22 8.219 3.697 8.219 8.22c0 4.522-3.696 8.218-8.219 8.218"
})));
export default SvgPinIcon;